import EditClipViewSelector from './EditClipViewSelector';

export default EditClipViewSelector;
